export default {"src":"/_next/static/media/gmail.3a3bb925.svg","height":26,"width":33,"blurWidth":0,"blurHeight":0};